import { render, staticRenderFns } from "./SlaTimeByPhase.vue?vue&type=template&id=681685a0&scoped=true&"
import script from "./SlaTimeByPhase.vue?vue&type=script&lang=js&"
export * from "./SlaTimeByPhase.vue?vue&type=script&lang=js&"
import style0 from "./SlaTimeByPhase.vue?vue&type=style&index=0&id=681685a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681685a0",
  null
  
)

export default component.exports